import React from "react";
import OrgNode from "./OrgNode";


const OrgChart = ({ data }) => {
    const renderNodes = (nodes) => {
        const gridCols =
            nodes.length === 1
                ? "grid-cols-1"
                : nodes.length === 2
                    ? "grid-cols-2"
                    : nodes.length === 3
                        ? "grid-cols-3"
                        : "grid-cols-4";

        const SM_gridCols =
            nodes.length === 1
                ? "grid-cols-1"
                : "grid-cols-2";

        return (
            <div className={`grid lg:${gridCols} md:${gridCols} sm:${SM_gridCols} gap-6`}>
                {nodes.map((node, index) => (
                    <div key={index}>
                        <OrgNode node={node} />
                        {node.children && (
                            <div className="mt-4">{renderNodes(node.children)}</div>
                        )}
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className="w-full min-h-screen bg-gray-50 py-8 px-4">
            <div className="max-w-7xl mx-auto">{renderNodes(data)}</div>
        </div>
    );
};
export default OrgChart;